module.exports = __webpack_public_path__ + "static/media/know-awair-front.7c79659f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/awair/know-awair-front.jpg
// module id = 236
// module chunks = 0